<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">자료실 {{regData.status == 'M' ? '수정' : '신규 등록'}}</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">제목</span></th>
                  <td><input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.title"></td>
                </tr>
                <tr>
                  <th><span class="emp">노출여부</span></th>
                  <td>
                      <div class="form_inline">
                        <div class="form_radio">
                          <input type="radio" id="exposureY" name="exposureYn" value="Y" v-model="regData.displayYn">
                          <label for="exposureY">노출</label>
                        </div>
                        <div class="form_radio">
                          <input type="radio" id="exposureN" name="exposureYn" value="N" v-model="regData.displayYn">
                          <label for="exposureN">미노출</label>
                        </div>
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">내용</span></th>
                  <td>
                    <small class="txt_info d-block mb-1">&#8251; 이미지는 10M 이하만 가능합니다.</small>
                    <Editor :content="regData.content" @getContents="fn_get_contents" />
                  </td>
                </tr>
                <tr>
                  <th><span>첨부파일</span></th>
                  <td>
                    <div class="form_inline">
                      <button class="btn btn_md btn_blue" @click="fn_resourcesFileUpload">파일업로드</button>
                      <input type="file" ref="resourcesFile" @change="fn_fileResourcesChange" hidden>
                      <ul class="file_list" v-if="regData.fileNm != ''">
                        <li><a href="" download="">{{regData.fileNm}}</a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_darkblue" @click="fn_resources_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import Editor from "@/components/common/Editor.vue"

    export default {
        name: 'ResourcesMngtReg',
        components: {
            Editor
        },
        mixins: [commonUtil],
        data() {
            return {
                regData : {
                    resourceId : "",
                    title : "",
                    content : "",
                    resourceFileId : "",
                    displayYn : "Y",
                    fileNm : "",
                    status : ''
                },
                upLoadFile : {
                    upFile : ''
                }
            }
        },
        created() {
          this.resourceId = this.$store.getters['resources/getResourceId'];
          console.log("@@@@ resourceId : "+this.resourceId);
          if(this.resourceId !== ''){
            this.regData.status = 'M'
            this.fn_search(this.resourceId);
          }
        },
        methods : {
            fn_move_page(){
                this.$router.push("/admin/board/resourcesMngt");
            },
            fn_resourcesFileUpload(){
                let fileInputElement = this.$refs.resourcesFile;
                fileInputElement.click();
            },
            fn_fileResourcesChange(e){
                this.upLoadFile.upFile = e.target.files[0];
                this.regData.fileNm = this.upLoadFile.upFile.name;
            },
            fn_resources_reg(){

                if(!this.regValidation()) return;
                console.log("@@@@ this.regData : %o",this.regData);

                var frm = new FormData();

                frm.append("file",this.upLoadFile.upFile);
                frm.append("key",JSON.stringify(this.regData));

               axios
                    .post("/api/admin/board/regResources", frm, {
                            "Content-Type": "multipart/form-data",
                            "Accept-Language" : "ko"})
                    .then((res) => {
                        console.log("@@@@ res : %o",res);

                        alert("저장되었습니다");
                        this.fn_move_page();

                    })
                    .catch((err) => console.log(err));

            },
            fn_get_contents(contents){
                this.regData.content = contents;
            },
            regValidation(){

                if(this.regData.title == ''){
                    alert("제목을 입력해주세요");
                    return false;
                }

                if(this.regData.content == "" ){
                    alert("내용를 입력해주세요");
                    return false;
                }

                return true;
            },
            fn_search(resourceId){

              let param = new Object();
              param.resourceId = resourceId;

              console.log("@@@@ param : %o",param);

              axios
                  .post("/api/admin/board/resourcesDetail", param)
                  .then((res) => {
                    console.log("@@@@ res : %o",res);

                    this.regData.resourceId = res.data.resource_id,
                    this.regData.title = res.data.title,
                    this.regData.content  = res.data.content,
                    this.regData.resourceFileId = res.data.file_id,
                    this.regData.displayYn = res.data.display_yn,
                    this.regData.fileNm = res.data.file_org_name

                  })
                  .catch((err) => console.log(err));

            },
        }
    }

</script>